<template>
  <div class="game-container" :style="getMainGameSyle()">
    <div id="game-container"><canvas id="gameCanvas" :style="getStyle()"> </canvas></div>
  </div>
</template>

<script>
import _ from 'lodash';
import createjs from 'createjs-collection';
import defaultMixins from '../../mixins/defaultMixinV2';
import createjsMixin from '../../mixins/createjsMixinV2';
export default {
  name: 'mp-dnd-v2',
  mixins: [defaultMixins, createjsMixin],
  components: {},
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      initData: {},
      width: 0,
      height: 0,
      offset: {},
      stage: {},
      figureArea: {},
      touchArea: {},
      line: {},
      mousedown: false,
      images: [],
      point: {},
      lines: [],
      moved: 0,
      ticker: false,
      animation: false,
      movesTo: [],
      targets: [],
      corrects: [],
      clones: [],
      maxClone: 0,
    };
  },
  beforeMount() {
    this.prototypeArray();
  },
  mounted() {
    this.ticker = createjs.Ticker;
    this.setDataGame();
    this.initGame();
    createjs.Touch.enable(this.stage);
    // // console.log(createjs.Touch.isSupported());
  },
  created() {},
  methods: {
    stageMouseDown(e) {
      if (!this.mousedown) {
        this.resetCheckStatus();
        var grx = -1;
        var ix = -1;

        this.images.forEach(function (gr, i) {
          gr.forEach(function (cont, j) {
            if (e.target.id == cont.id) {
              ix = j;
              grx = i;
            }
          });
        });

        if (ix >= 0 && grx >= 0 && !this.images[grx][ix].block) {
          if (
            this.clones[grx][this.images[grx][ix].id] !== undefined &&
            this.clones[grx][this.images[grx][ix].id].length > 0
          ) {
            if (this.stage.numChildren <= this.maxClone) {
              this.moved = this.clones[grx][this.images[grx][ix].id].shift();
              this.moved.cache(-this.moved.width, -this.moved.height, this.moved.width * 2, this.moved.height * 2);
              this.stage.addChild(this.moved);
            } else this.moved = this.images[grx][ix];
          } else this.moved = this.images[grx][ix];
          if (this.moved) {
            this.moved.sorts = this.findInTargets(this.moved);
            this.moved.stageX = e.stageX - this.offset.x;
            this.moved.stageY = e.stageY - this.offset.y;
            this.moved.scaleX = 1;
            this.moved.scaleY = 1;
            this.stage.setChildIndex(this.moved, this.stage.getNumChildren() - 1);
            this.stage.on('stagemousemove', this.stageMouseMove);
            this.mousedown = true;
          }
        }
      }
    },
    findInTargets(item, flg) {
      var inx = -1,
        grx = -1,
        it = -1;
      this.targets.forEach(function (tar, i) {
        tar.forEach(function (child, j) {
          child.forEach(function (its, k) {
            if (its !== undefined && its.id == item.id) {
              grx = i;
              it = j;
              inx = k;
            }
          });
        });
      });
      if (inx > -1 && grx > -1 && it > -1 && flg === true) {
        this.targets[grx][it][inx] = undefined;
      }
      return inx !== -1 && flg !== true ? inx : false;
    },
    dropElem(item, del) {
      if (this.animation !== false) {
        item.pos = { x: item.posStart.x, y: item.posStart.y };
        item.move = true;
        this.movesTo.push(item);
      } else {
        item.x = item.posStart.x;
        item.y = item.posStart.y;
        this.removeClone(item.x, item.y);
      }
      if (del === true) {
        if (del !== false) this.findInTargets(item, true);
        item.sorts = false;
      }
    },
    stageMouseMove(e) {
      if (this.mousedown) {
        this.moved.x += e.stageX - this.moved.stageX - this.offset.x;
        this.moved.y += e.stageY - this.moved.stageY - this.offset.y;
        this.moved.stageX = e.stageX - this.offset.x;
        this.moved.stageY = e.stageY - this.offset.y;
      }
    },
    stageMouseUp(e) {
      if (this.mousedown) {
        this.mousedown = false;
        var self = this;
        var ix = -1,
          grx = -1;
        var newX = false,
          newY = false,
          idHook = false,
          drop = false;
        var source = false;

        this.stage.getObjectsUnderPoint(this.moved.stageX, this.moved.stageY).forEach(function (bmp) {
          if (bmp.parent.type == 'source' && bmp.id !== self.moved.id) source = bmp;
          if (bmp.type == 'hook') {
            newX = bmp.x;
            newY = bmp.y;
            let id = bmp.id.split('-');
            if (Number.isInteger(parseInt(id[1]))) idHook = parseInt(id[1]);
          }
          self.images.forEach(function (gr, i) {
            gr.forEach(function (indx, j) {
              if (indx.id == bmp.id) {
                ix = j;
                grx = i;
              }
            });
          });
        });
        if (this.images[grx][ix].type === 'target') {
          this.images[grx][ix].children.forEach(function (child) {
            if (child.type == 'hook' && newX === false) {
              self.dropElem(self.moved, true);
              drop = true;
            }
          });
        }
        if (this.images[grx][ix].type !== 'target') this.dropElem(this.moved, true);
        else if (drop === false) {
          if (this.targets[grx][ix] == undefined) this.targets[grx][ix] = [];
          if (this.images[grx][ix].hooks.length == 0) {
            this.findInTargets(this.moved, true);
            this.targets[grx][ix].push(this.moved);
          } else if (source === false) {
            if (this.moved.sorts === false) {
              var c = 0;
              this.targets[grx][ix].forEach(function (tar) {
                if (tar !== undefined) c++;
              });
              if (
                this.images[grx][ix].hooks.length > this.targets[grx][ix].length ||
                this.targets[grx][ix].length > c
              ) {
                if (this.animation !== false) {
                  this.moved.pos = { x: newX + this.images[grx][ix].x, y: newY + this.images[grx][ix].y };
                  this.moved.move = true;
                  this.movesTo.push(this.moved);
                } else {
                  this.moved.x = newX + this.images[grx][ix].x;
                  this.moved.y = newY + this.images[grx][ix].y;
                }
                if (idHook === false) {
                  let flg = false,
                    drop = false;
                  for (let i = 0; i < this.targets[grx][ix].length; i++) {
                    if (
                      this.targets[grx][ix][i] !== undefined &&
                      this.targets[grx][ix][i].x === newX + this.images[grx][ix].x &&
                      this.targets[grx][ix][i].y === newY + this.images[grx][ix].y
                    ) {
                      drop = true;
                      break;
                    }
                  }
                  if (drop === true) this.dropElem(this.moved);
                  else {
                    for (let i = 0; i < this.targets[grx][ix].length; i++) {
                      if (this.targets[grx][ix][i] === undefined) {
                        this.targets[grx][ix][i] = this.moved;
                        flg = true;
                        break;
                      }
                    }
                    if (!flg) this.targets[grx][ix].push(this.moved);
                  }
                } else {
                  if (this.targets[grx][ix] === undefined) this.targets[grx][ix] = [];
                  this.targets[grx][ix][idHook] = this.moved;
                }
              } else this.dropElem(this.moved);
            } else {
              this.findInTargets(this.moved, true);
              if (this.animation !== false) {
                this.moved.pos = { x: newX + this.images[grx][ix].x, y: newY + this.images[grx][ix].y };
                this.moved.move = true;
                this.movesTo.push(this.moved);
              } else {
                this.moved.x = newX + this.images[grx][ix].x;
                this.moved.y = newY + this.images[grx][ix].y;
              }

              let flg = false;
              for (let i = 0; i < this.targets[grx][ix].length; i++) {
                if (this.targets[grx][ix][i] === undefined) {
                  this.targets[grx][ix][i] = this.moved;
                  flg = true;
                  break;
                }
              }
              if (!flg) this.targets[grx][ix].push(this.moved);
            }
          } else {
            if (this.moved.pos === undefined) {
              this.moved.pos = this.moved.posStart;
            }
            if (this.animation !== false) {
              this.moved.move = true;
              this.movesTo.push(this.moved);
            } else {
              this.moved.x = this.moved.pos.x;
              this.moved.y = this.moved.pos.y;
            }
          }
        }
      }

      this.stage.removeAllEventListeners('stagemousemove');
    },

    tick(e) {
      if (this.movesTo.length > 0) {
        for (let i = 0; i < this.movesTo.length; i++) {
          this.anim(this.movesTo[i], { x: this.movesTo[i].pos.x, y: this.movesTo[i].pos.y, move: true });
          if (this.movesTo[i].x == this.movesTo[i].pos.x && this.movesTo[i].y == this.movesTo[i].pos.y) {
            let x = this.movesTo[i].x,
              y = this.movesTo[i].y;

            this.movesTo.splice(i, 1);
            this.removeClone(x, y);
          }
        }
      } else {
        if (!this.ticker.paused) {
          if (!this.mousedown) {
            this.ticker.paused = true;
            this.moved.move = false;
          }
        }
      }
      this.stage.update(e);
    },
    removeClone(x, y) {
      var clone = false;
      var childs = this.stage.getObjectsUnderPoint(x, y);
      childs.forEach(function (shape) {
        if (shape.parent.type == 'clone') {
          clone = shape;
        }
      });
      if (clone !== false) {
        let id = clone.parent.id.split('-');
        var remove = false;
        childs.forEach(function (shape) {
          if (shape !== clone && (shape.parent.id == id[0] || (shape.origin != undefined && id[0] == shape.origin))) {
            remove = true;
          }
        });
        if (remove) {
          clone.parent.uncache();
          for (let i = 0; i < this.clones.length; i++) {
            if (this.clones[i] !== undefined && this.clones[i][clone.parent.origin] !== undefined) {
              this.clones[i][clone.parent.origin].unshift(clone.parent);
              break;
            }
          }
          this.stage.removeChild(clone.parent);
        }
      }
    },
    resetGameAction() {
      this.newGame();
    },
    checkGameAction() {
      // console.log('CHECK');
      var isCorrect = true;
      var self = this;

      this.images.forEach(function (gr, i) {
        gr.forEach(function (bmp, j) {
          if (bmp.type == 'target') {
            // GDY NIE MA Ĺ»ADNEGO WRZUCONEGO ELEMENTU DO TARGETU
            if (self.targets[i][j] === undefined) {
              if (bmp.correct.length > 0) isCorrect = false;
            } else {
              // GDY SÄ„ OKREĹšLONE KOTWICE
              var nulls = 0;
              if (bmp.hooks.length > 0) {
                var count = 0;
                bmp.hooks.forEach(function (hook, k) {
                  let id = hook.id.split('-');
                  if (id[0] == '') {
                    nulls++;
                  } else {
                    self.targets[i][j].forEach(function (tar, l) {
                      if (tar !== undefined) {
                        let idT = tar.type == 'clone' ? tar.id.split('-')[0] : tar.id;
                        if (bmp.hooksCount === undefined) {
                          if (
                            idT == id[0] &&
                            ((Number.isInteger(parseInt(id[1])) && l == id[1]) || !Number.isInteger(parseInt(id[1])))
                          ) {
                            if (self.initData.corrBlock === true) tar.block = true;
                            count++;
                          }
                        } else {
                          bmp.correct.forEach(function (corr) {
                            if (corr.id == idT) {
                              if (self.initData.corrBlock === true) tar.block = true;
                              count++;
                            }
                          });
                        }
                      }
                    });
                  }
                });
                var drops = 0;
                self.targets[i][j].forEach(function (tar) {
                  if (tar !== undefined) drops++;
                });

                if (
                  ((nulls == 0 && count == bmp.hooks.length) || (nulls > 0 && count + nulls === bmp.hooks.length)) &&
                  self.initData.corrBlock === true &&
                  drops == count
                ) {
                  self.targets[i][j].forEach(function (tar, l) {
                    if (self.initData.corrBlock === true && tar !== undefined) tar.block = true;
                  });
                } else {
                  //if ((nulls == 0 && count != bmp.hooks.length) || (nulls > 0 && count + nulls !== bmp.hooks.length)) {
                  isCorrect = false;
                  if (self.initData.removeInCorrects) {
                    self.removeInCorrects(i, j);
                  }
                }

                // GDY NIE MA KOTWIC
              }
              if (bmp.hooks.length == 0 || nulls === true) {
                var corrs = 0;
                self.targets[i][j].forEach(function (tar) {
                  if (tar !== undefined) {
                    let idT = tar.type == 'clone' ? tar.id.split('-')[0] : tar.id;
                    for (let k = 0; k < bmp.correct.length; k++) {
                      if (idT == bmp.correct[k].id) {
                        if (self.initData.corrBlock === true) tar.block = true;
                        corrs++;
                      }
                    }
                  }
                });

                if (corrs < bmp.correct.length) {
                  isCorrect = false;
                  if (self.initData.removeInCorrects) {
                    self.removeInCorrects(i, j);
                  }
                } else if (self.initData.corrBlock === true) {
                  self.targets[i][j].forEach(function (tar) {
                    if (tar !== undefined) {
                      let idT = tar.type == 'clone' ? tar.id.split('-')[0] : tar.id;
                      for (let k = 0; k < bmp.correct.length; k++) {
                        if (idT == bmp.correct[k].id && self.initData.corrBlock === true) tar.block = true;
                      }
                    }
                  });
                }
              }
            }
          }
        });
      });
      return isCorrect;
    },
    removeInCorrects(i, j) {
      var k = this.targets[i][j].length - 1;
      do {
        if (this.targets[i][j][k] !== undefined) {
          if (
            this.initData.corrBlock !== true ||
            (this.initData.corrBlock === true && this.targets[i][j][k].block === false)
          ) {
            this.targets[i][j][k].block = false;
            this.dropElem(this.targets[i][j][k], true);
          }
        }
        k--;
      } while (k >= 0);
    },
    getMainGameSyle() {
      return _.merge({}, this.getCustomStyle(this.startGameConfig.mainGameSyle));
    },
    getStyle() {
      return _.merge({}, this.getCustomStyle(this.startGameConfig));
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item && item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
  beforeDestroy() {
    this.beforeDestroy();
  },
};
</script>
<style lang="scss"></style>
<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/fonts';
.game-container {
  display: flex;
  padding: 160px 50px 100px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

#game-container {
  margin: 0;
  width: 100%;
  height: 100%;
}

canvas {
}
</style>
